import { render, staticRenderFns } from "./goodsShelf.vue?vue&type=template&id=3d68c66e&scoped=true"
import script from "./goodsShelf.vue?vue&type=script&lang=js"
export * from "./goodsShelf.vue?vue&type=script&lang=js"
import style0 from "./goodsShelf.vue?vue&type=style&index=0&id=3d68c66e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68c66e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d68c66e')) {
      api.createRecord('3d68c66e', component.options)
    } else {
      api.reload('3d68c66e', component.options)
    }
    module.hot.accept("./goodsShelf.vue?vue&type=template&id=3d68c66e&scoped=true", function () {
      api.rerender('3d68c66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsWarehouse/goodsShelf/goodsShelf.vue"
export default component.exports